import { useSelector } from 'react-redux';

const usePriceHikeInfo = (goalUID) => {
  const { priceHikeInfoArr } = useSelector(({ others }) => ({
    priceHikeInfoArr: others.priceHikeInfo || []
  }));

  const priceHikeInfoIndex = priceHikeInfoArr.findIndex((obj) => {
    const priceHikeSupportedGoals = obj.active_goals?.split(',');
    return (
      obj.is_active &&
      new Date(obj.expiry_date) >= new Date() &&
      priceHikeSupportedGoals?.includes(goalUID)
    );
  });

  return priceHikeInfoArr[priceHikeInfoIndex];
};

export default usePriceHikeInfo;
